import { render, staticRenderFns } from "./factoryInfo2.vue?vue&type=template&id=53a8bd92"
import script from "./factoryInfo2.vue?vue&type=script&lang=js"
export * from "./factoryInfo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports